export default {
    IMPORT_CENTER: "import", //导入
    //员工信息详情
    //15137244893184  查看
    //56147288027136 修改
    EMP_DETAIL: {
        VIEW: '15137244893184',
        UPDATE: '56147288027136',
        BASEINFO: "pms_base_info",
        POSTINFO: "pms_post_info",
        PAYINFO: "pms_pay_info",
        CONTRACTINFO: "pms_contract_info",
        ARCHIVESINFO: "pms_archives_info",
        MATERIALINFO: "pms_material_info",
        RECORDINFO: "pms_record_info",
    },

    
    MENU_IDS: {
        ADD_EMP: '17641458208768', //在职 --- 添加员工
        ADD_PENDING_EMP: '20390463635456', //待入职 ---- 添加
        ADD_DRZINTERN_SHIP: '389927317159936', //待入职 --  添加实习生
        ADD_ENTRYREGISTRATION: '15167165693952', //录用审批 --  添加录用
        ENTRYREGISTRATION_ALL_LIST: '25421830225920', //录用审批 --  查看全部 
        ADD_INTERN_SHIP: '388851033587712', //录用审批 --  添加实习生
        ENTRYREGISTRATION_LIST: '17202804338688', //录用审批 -- 列表
        EXPORT_REMUNERATION: '18681696854016',  //导出薪酬
        EXPORT_ALLOWANCE: '18705344339968', //导出津贴
        IMPORT_SPECIAL_INFORMATION: '327648395399168', //导入特殊字段
        REMUNERATION_FORM: '282569795178496',
        CUSTOM_FIELD_SET:"127615107403776",//自定义字段设置
        LEAVE_EXPORT_REMUNERATION: '45964583862272',  //导出薪酬
        LEAVE_EXPORT_ALLOWANCE: '45992119468032', //导出津贴
        BATCH_EMP_BASEINFO_ENTRY: '20831275999232', //待入职 ---- 批量确认入职
    },
    OPTYPE: {
        ZXYZ: 3//入职征信验证
    },
    //导入
    APPLICATION_TYPE: {
        INDUCTION: 4, //入职
        POSITIVE: 5, //转正
        DEPARTURE: 8, //离职
        THE_POST: 7, //调岗
        SALARY_INCREASE: 6, //调薪
        EMP_DELETE: 14, //删除员工
         AllOWANCE:23,//调整津贴
    }, 
    APPROVAL_TYPE:{//审批申请类型
        1:"DayOff",//请假
        2:"OverTime",//加班
        3:"ReplenishSign",//补签
        4:"OnJob", //入职
        5:"Regular",//转正
        6:"AdjustSalary",//调薪
        7:"AdjustPost",//调岗
        8:"Leave",//离职
        9:"DeptMove",//移动部门
        10:"MonthlyReport",//月报归档
        11:"Expense",//报销
        12:"Approve",
        13:"Custom",//自定义
        14:"DeleteEmp",//删除员工
        15:"Contract",//续签合同
        17:"Extension",//年假延休
        18:"BatchOverTime",//批量加班
        19:"BeAway", //公出
        20:"RevokeDayOff", //销假
        23:"AdjustProject", //津贴
        24:"OverTimeAndRest", //夜班&补休：仅中软用
        26:"AttLocation", //考勤地点
        29:"BatchAttLocation", //批量考勤地点
        30:"CreateAttLocation", //新增考勤地点
        31:"CloseAttLocation" //关闭考勤地点
    },
    //审批状态
    EXAMINATION_APPROVAL_STATUS: {
        THROUGH: 1, //通过
        PENDING: 2, //待审
        REJECTED: 3,  //驳回
        UNDO: 4 //撤回
    },
    //员工管理
    EMP_MANAGE: { 
        MAIN: "empmanage",  
        ENTRYREGISTRATION: "entryregistration", //入职登记
        PENDING: "pending", //待生效员工
        ONJOB: "onjob", //在职
        LEAVE: "leave", //离职
        ARCHIVES: "archives", //档案
        APPLYRECORD: "applyrecord", //申请记录
        POSITIVE_MANAGE: "positivemanage", //转正
        LEAVE_MANAGE: "leavemanage", //离职
        POST_MANAGE: "postmanage", //离职
        CHANGE_SALARY:"changesalarymanage",//调薪

        //kaoqin
        ATTENDANCE: 'attendance', //考勤假期
        ATTENDANCEPLACE: "attendancePlace", //调整考勤地点
        MANAGEMENTREGIONAL: "managementRegional", //调整管理地域
        SHIFT: "shift", //调整班次
        INTERN: "intern", //实习生管理
        DIRECTLIST: "directlist" //直接主管修改  
    },
    //审批管理
    APPRO_MANAGE:{
        MAIN:"approvalManager",
        PENDING:"pending",
        ALEADY:"aleadyAppro",
        ADMINPENDING:"adminPedding",
        HISTORY:"history",
        BATCH:"batchApproval"
    },
    //电子盖章
    ELECSIGN_MANAGE:{
        MAIN:"elecsignmanage",
        GAIKUANG:"gaikuang",
        ELECSIGN:"elecsign",
		ZUOFEI:"zuofei",
        SIGNVIEW:"signview",
		GAIZHANG:"gaizhang",
    },
    //审批流
    APPROVAL_FLOW: {
        NO_APPROVAL: 1,
        FIXED_APPROVAL: 2,
        OPTIONAL_APPROVAL: 3,
    },
    //业务类型（1请假 2加班 3补签 4入 5转 6调薪 7调岗 8离职 9移动部门 10月报归档 11报销 12发薪审批 13自定义 15合同  23津贴)
    SOURCE_TYPE: {
        LEAVE: 1,
        WORK_OVERTIME: 2,
        RETROACTIVE: 3,
        CAREER: 4,
        POSITIVE: 5,
        SALARY_INCREASE: 6,
        THE_DUTY: 7,
        DEPARTURE: 8,
        MOBILE_DEPARTMENT: 9,
        MONTHLY_ARCHIVE: 10,
        FOR_REIMBURSEMENT: 11,
        SALARY_APPROVAL: 12,
        THE_CUSTOM: 13,
        DELETE_STAFF: 14,
        CONTRACT: 15,
        LEAVING_IS_IN: 21,
        THE_DUTY_ZR:22, //中软定制调岗 
        AllOWANCE:23,
        TURN_FULL: 27, //转全职
        INTERN: 28, //实习生  
        PLACE:26, //单个考勤地点的
        SUMPLACE:29, //批量考勤地点的  
        APPLYPLACE:30, //考勤地点申请 新增
        CLOSEYPLACE:31, //考勤地点申请
    },
    //区分新版旧版   新版传2 旧版不传
    VERSION_DISTINGUISH: {
        NEW_VERSION: 2
    },

    //是否是实习生
    IS_INTERN: {
        YES: 1,
        NO: 0,
        INTERN_TYPE: 4, //实习生类型ID
        NAME: 'traineEntry',
        QUANZHI: 'train'
    }, 

    OP_TYPE: {
        POOL: 'pool',
        POOLTRAINE: 'poolTraine',
        WAITENTRY: 'waitEntry',
        WAITENTRYTRAINE: 'waitEntryTraine',
        ENTRY: 'entry',
        ENTRYTRAINE: 'entryTraine',
        TRAIN: 'train',
        LEAVEENTRY: 'leaveEntry',
        EMPLOYMENT: 'employment',
        UPDATEEMPLOYMENT: "updateEmployment"
    },
    
    //新版本请求成功返回
    RES_CODE: {
        SUCCESS: "0"
    },
    MENU_CODE: {
        SEND_SMS: "SEND_SMS",
        SEND_MAIL: "SEND_MAIL",
        SEND_PUSH: "SEND_PUSH"
    }, 
    SEND_PUSH_BG: ['1182959119511506946','1182959386814500866'], //发送通知背景图
    NOTICE: {
        DEPT_TYPE: 1,
        PERSONAL_CENTER: {
            INDEX: 'personalcenter',
            COMPANY_INFO: 'companyinfo',
            PAY_SMS: 'paysms',
            MY_ORDER: 'myorder'
        },
        WORK_BENCH: "workbench",
        ADDRESS_BOOK: "addressbook",
        ADMIN: "admin"
    },
    MENU_ALIAS: {
        ADDRESSBOOK: 'addressbook'
    },
    FIELD_TYPE:{ //字段类型
        TEXT:"1",
        TEXTAREA:"2",
        SELECT:"3",
        RADIO:"4",
        CHECKBOX:"5",
        DATETIME:"6",
        DATE:"7"
    },
    //员工设置业务类型： 1：基本信息设置,2:岗位, 3:薪酬字段 , 4:档案， 5:征信字段, 6:津贴字段  7:离职信息, 8:组织岗位设置， 9：实习生设置
    EMP_SET_BUS_TYPE:{
        EMP_BASE_INFO:1,
        EMP_POST:2,
        EMP_SALARY:3,
        EMP_RECORD:4,
        EMP_BLACK_WHITE:5,
        EMP_SUBSIDY:6,
        EMP_LEAVE:7,
        EMP_DEPT_POST:8,
        EMP_TRAINEE:9
    },
    // MorConfirm提示框类型 1导入成功,2导入失败,3文件上传完成
    MORCONFIRMTYPE: {
        MORCONFIRMSUCCESS:1,
        MORCONFIRMERROR:2,
        MORCONFIRMCOMPLETE:3
    }

}
